import fetch from 'utils/fetch';
import { receiveCatalog } from './catalog';

export const REQUEST_NODE = 'REQUEST_NODE';
export const NODE_CREATED = 'NODE_CREATED';
export const NODE_UPDATED = 'NODE_UPDATED';

function requestNode(node) {
  return {
    type: REQUEST_NODE,
    payload: {
      node,
    },
  };
}

function nodeCreated(node) {
  return {
    type: NODE_CREATED,
    payload: {
      node,
    },
  };
}

function nodeUpdated(node) {
  return {
    type: NODE_UPDATED,
    payload: {
      node,
    },
  };
}

function nodeForm(node) {
  const data = new FormData();

  data.append('node', JSON.stringify(node));
  data.append('image', node.image);
  data.append('tabletImage', node.tablet_image.image);

  return data;
}

function reorder(catalog, node, newOrder) {
  return dispatch => {
    dispatch(requestNode(node));
    return fetch(`/catalogs/${catalog}/nodes.json/${node.id}/order`, {
      method: 'put',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        order: newOrder,
      }),
    })
      .then(res => res.json())
      .then(nodes => {
        dispatch(receiveCatalog(nodes));
      });
  };
}

export function createNode(catalog, parent, node) {
  return dispatch => {
    dispatch(requestNode(node));

    const data = nodeForm(node);

    return fetch(`/catalogs/${catalog}/nodes.json?parent=${parent}`, {
      method: 'post',
      body: data,
    })
      .then(res => res.json())
      .then(created => {
        dispatch(nodeCreated(created));
      });
  };
}

export function createEntityNode(catalog, parent, source, entity) {
  return dispatch => {
    dispatch(requestNode(entity));

    return fetch(`/catalogs/${catalog}/source.json?parent=${parent}`, {
      method: 'post',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        source: source,
        entity: entity,
      }),
    })
      .then(res => res.json())
      .then(created => {
        dispatch(nodeCreated(created));
      });
  };
}

export function updateNode(catalog, node) {
  return dispatch => {
    dispatch(requestNode(node));

    const data = nodeForm(node);

    return fetch(`/catalogs/${catalog}/nodes.json/${node.id}`, {
      method: 'post',
      body: data,
    })
      .then(res => res.json())
      .then(updated => {
        dispatch(nodeUpdated(updated));
      });
  };
}

export function deleteNode(catalog, node) {
  return dispatch => {
    dispatch(requestNode(node));

    return fetch(`/catalogs/${catalog}/nodes.json/${node.id}`, {
      method: 'delete',
    })
      .then(res => res.json())
      .then(nodes => {
        dispatch(receiveCatalog(nodes));
      });
  };
}

export const moveUpNode = (catalog, node) =>
  reorder(catalog, node, node.order - 1);
export const moveDownNode = (catalog, node) =>
  reorder(catalog, node, node.order + 1);



// WEBPACK FOOTER //
// ./src/modules/catalog/actions/node.js